import RestDataSource from './restdatasource';
import { Global_var } from '../global/global_var';
import { LoginService } from "./login.service";

 export const FetchNotificationService = {
  fetchNotification,
  fetchNotificationCount,
  fetchNotificationByDates,
  updateReadUnreadAlerts,
  fetchLatestThreeNotification,
  documentDownload,
  fetchNotificationDarft,
  deleteDarft,
  getCount,
  updateReadUnread,
  fetchNotificationDarftById,
  updateDraftData,
  saveDraftData,
  ComposeSentStore
};     

  function fetchNotification(Id,fn, fnError) {
    var url = Global_var.BASEURL + Global_var.URL_NOTIFICATION_EVENTS;

    return new RestDataSource(url, fnError).GetOneByParam(Id,(res) => {
      if (res != null) {
        if (res.headers["jtitoken"] != null) {
          localStorage.setItem("jti-token", res.headers.jtitoken);
        }
        fn(res.data);
      }
    });
  }

  function fetchNotificationCount(param, fn, fnError) {
     var url = Global_var.BASEURL + Global_var.URL_MSG_COUNT;
     return new RestDataSource(url, fnError).GetOneByParam(param, (res) => {
      if (res != null) {
        if (res.headers["jtitoken"] != null) {
          localStorage.setItem("jti-token", res.headers.jtitoken);
        }
        fn(res.data);
      }
    });
   }

   function fetchNotificationByDates(param, fn, fnError) {
    var url = Global_var.BASEURL + Global_var.URL_MSG_LIST_BY_DATE;
    return new RestDataSource(url, fnError).GetOneByParam(param, (res) => {
     if (res != null) {
       if (res.headers["jtitoken"] != null) {
         localStorage.setItem("jti-token", res.headers.jtitoken);
       }
       fn(res.data);
     }
   });
  }

  function fetchLatestThreeNotification(param, fn, fnError) {
    var url = `${Global_var.BASEURL}${Global_var.URL_LATEST_TREE_MSG}`;
    return new RestDataSource(url, fnError).GetOneByParam(param, (res) => {
      if (res != null) {
        if (res.headers["jtitoken"] != null) {
          localStorage.setItem("jti-token", res.headers.jtitoken);
        }
        fn(res.data);
      }
    });
  }

  function updateReadUnreadAlerts(data, fn) {
    LoginService.TokenUser(res => {
      localStorage.setItem("jwt-token", res.responseObject);
      var url = Global_var.BASEURL + Global_var.URL_UPDATE_MSG_COUNT;
      return new RestDataSource(url).UpdateOneByParam(data, '',res => fn(res.data));
    });
  }


   function documentDownload(Id, fn, fnError) {
    var url = Global_var.BASEURL + Global_var.URL_NOTIFICATION_DOCUMENT_DOWNLOAD;
    return new RestDataSource(url, fnError).GetOneByParam(Id, (res) => {
     if (res != null) {
       if (res.headers["jtitoken"] != null) {
         localStorage.setItem("jti-token", res.headers.jtitoken);
       }
       fn(res.data);
     }
   });
  }
  function fetchNotificationDarft(Id, fn, fnError) {
    var url = Global_var.BASEURL + Global_var.URL_NOTIFICATION_EVENTS_DRAFT;
    // var url="http://192.168.10.75:8024"+ Global_var.URL_NOTIFICATION_EVENTS_DRAFT;
    return new RestDataSource(url, fnError).GetOneByParam(Id, (res) => {
      if (res != null) {
        if (res.headers["jtitoken"] != null) {
          localStorage.setItem("jti-token", res.headers.jtitoken);
        }
        fn(res.data);
      }
    });
  }  
  function deleteDarft(id, fn,fnError) {
    LoginService.TokenUser(res => {
      localStorage.setItem("jwt-token", res.responseObject);
      
      // var url ="http://192.168.10.75:8024" + Global_var.URL_NOTIFICATION_EVENTS_DELETE_DRAFT;
      var url = Global_var.BASEURL + Global_var.URL_NOTIFICATION_EVENTS_DELETE_DRAFT;
      new RestDataSource(url).StoreOneByParam(id,'',res => fn(res.data));
    });
  }
  function getCount(Id, fn, fnError) {
    var url = Global_var.BASEURL + Global_var.URL_INBOX_MESSAGE_COUNT;
    return new RestDataSource(url, fnError).GetOneByParam(Id, (res) => {
      if (res != null) {
        if (res.headers["jtitoken"] != null) {
          localStorage.setItem("jti-token", res.headers.jtitoken);
        }
        fn(res.data);
      }
    });
  }
  function updateReadUnread(data, fn) {
    LoginService.TokenUser(res => {
      localStorage.setItem("jwt-token", res.responseObject);
      var url = Global_var.BASEURL + Global_var.URL_UPDATE_MESSAGE_COUNT;
      return new RestDataSource(url).Store(data, res => fn(res.data));
    });
  }
  function fetchNotificationDarftById(Id, fn, fnError) {
    var url = Global_var.BASEURL + Global_var.URL_NOTIFICATION_EVENTS_DRAFT_BY_ID;
    return new RestDataSource(url).GetOneByParam(Id, res => fn(res.data));
  }
  function updateDraftData(data, fn) {
    LoginService.TokenUser(res => {
      localStorage.setItem("jwt-token", res.responseObject);
      var url = Global_var.BASEURL + Global_var.URL_NOTIFICATION_EVENTS_UPDATE_DRAFT;
      return new RestDataSource(url).Update(data,res => fn(res.data));
    });
  }
  function saveDraftData(data, fn) {
    LoginService.TokenUser(res => {
      localStorage.setItem("jwt-token", res.responseObject);
      var url = Global_var.BASEURL + Global_var.URL_NOTIFICATION_EVENTS_SAVE_DRAFT
      return new RestDataSource(url).Store(data,res => fn(res.data));
    });
  }
  function ComposeSentStore(data, fn) {
    LoginService.TokenUser(res => {
      localStorage.setItem("jwt-token", res.responseObject);
      var url = Global_var.BASEURL + Global_var.URL_NOTIFICATION_EVENTS_SEND_MAIL
      return new RestDataSource(url).Store(data,res => fn(res.data));
    });
  }

